module.exports = __webpack_public_path__ + "static/img/logob.81724f5d.png";